module.exports = __webpack_public_path__ + "static/img/story3.768dcee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/story3.jpg
// module id = wb4a
// module chunks = 0